<template>
  <div>
    <van-sticky :offset-top="scrollTop">
      <van-row class="head">
        <van-col span="6">企业名称</van-col>
        <van-col span="6">联系人</van-col>
        <van-col span="6">产品名称</van-col>
        <van-col span="6">提交时间</van-col>
      </van-row>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" offset="50">
      <van-cell v-for="item in financingList" :key="item.id" @click="getId(item.id)">
        <van-row class="list">
          <van-col span="6" class="van-multi-ellipsis--l2"><span>{{item.title}}</span></van-col>
          <van-col span="6">{{item.name}}</van-col>
          <van-col span="6">{{item.titlename}}</van-col>
          <van-col span="6" class="van-multi-ellipsis--l2">{{item.create_time}}</van-col>
        </van-row>
        <transition name="van-fade">
          <van-row class="operation" v-show="item.id === id">
            <van-col span="12" @click.stop="CheckTheFinancing">查看</van-col>
            <van-col span="12" @click.stop="delese">删除</van-col>
          </van-row>
        </transition>
      </van-cell>
    </van-list>

    <!-- 详情展示框 -->
    <van-popup v-model="show" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <h5 class="popup-title">详细信息</h5>
      <div class="information">
        <div class="popup-header">企业基本信息</div>
        <p>企业名称：{{financingDetails.title}}</p>
        <p>联系人：{{financingDetails.name}}</p>
        <p>邮箱：{{financingDetails.email}}</p>
        <p>用款时间：{{financingDetails.yksj}}</p>
        <p>申请额度：{{financingDetails.sqed}}</p>
        <p>资金用途：{{financingDetails.zjyt}}</p>
        <p>还款来源：{{financingDetails.hkly}}</p>
        <p>所属行业：{{financingDetails.syhy}}</p>
        <p>办公地址：{{financingDetails.companyadd}}</p>
        <p>注册地址：{{financingDetails.zhuceadd}}</p>
        <p>纳税地：{{financingDetails.nashuiadd}}</p>
        <p>上年度纳税总额：{{financingDetails.sndnsze}}</p>
        <p>成立时间：{{financingDetails.chengli}}</p>
        <p>注册资本：{{financingDetails.zczb}}</p>
        <p>法定代表人：{{financingDetails.fddbr}}</p>
        <p>实际控制人：{{financingDetails.sjkzr}}</p>
        <p>创始人：{{financingDetails.csr}}</p>
        <p>营业范围：{{financingDetails.yingye}}</p>
        <p>主营业务及其产品介绍：{{financingDetails.intro}}</p>
        <p>业务近期情况：{{financingDetails.introa}}</p>
        <div class="popup-header m57">近三年主要财务数据</div>
        <div class="m35">{{tYear-3}}</div>
        <p>营业收入：{{financingDetails.yysra}}</p>
        <p>净利润：{{financingDetails.jlra}}</p>
        <p>总资产：{{financingDetails.zzca}}</p>
        <div class="m35">{{tYear-2}}</div>
        <p>营业收入：{{financingDetails.yysrb}}</p>
        <p>净利润：{{financingDetails.jlrb}}</p>
        <p>总资产：{{financingDetails.zzcb}}</p>
        <div class="m35">{{tYear-1}}</div>
        <p>营业收入：{{financingDetails.yysrc}}</p>
        <p>净利润：{{financingDetails.jlrc}}</p>
        <p>总资产：{{financingDetails.zzcc}}</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { financingList, ModifyState, findOrderDetail } from '@/api/financing.js'
import delItem from '@/utils/delitem.js'
export default {
  name: 'project',
  props: {
    inpshow: {
      type: Boolean,
      default: false
    },
    searchVal: {
      type: String,
      default: ''
    },
    scrollTop: {
      type: Number,
      default: 44
    }
  },
  data () {
    return {
      id: null,
      show: false, // 详情展示框
      isSearch: false, // 判断要获取搜索数据还是所有数据
      financingList: [], // 数据列表
      financingDetails: {}, // 数据详情
      page: 0,
      loading: false,
      finished: false,
      isData: false // 是否停止加载 true：停止加载，false：继续加载
    }
  },
  created () {
    const myDate = new Date()
    this.tYear = myDate.getFullYear()
  },
  watch: {
    inpshow (newVal, oldVal) {
      if (this.searchVal) {
        this.id = -1
        this.isSearch = false
        this.onLoad(true)
      }
    },
    searchVal (newVal, oldVal) {
      this.id = -1
      this.isSearch = true
      this.onLoad(true)
    }
  },
  methods: {
    getId (id) {
      if (this.id === id) {
        this.id = -1
      } else {
        this.id = id
      }
    },

    // 分页加载
    async onLoad (type) {
      if (type) {
        this.financingList = []
        this.page = 0
        this.loading = true
        this.finished = false
        this.isData = false
      }
      this.page += 1
      if (this.isSearch) {
        await this.getfinancingList(this.page, this.searchVal)
      } else {
        await this.getfinancingList(this.page)
      }
      await this.$delay(800)
      this.loading = false
      if (this.isData) {
        this.loading = false
        this.finished = true
      }
    },
    // 项目列表数据
    async getfinancingList (page, searchVal) {
      try {
        const data = await financingList(page, searchVal)
        if (data.error_code === 1) {
          this.financingList = [...this.financingList, ...data.data]
          if (data.data.length < 10) this.isData = true
        } else {
          this.$toast('搜索失败')
        }
      } catch (error) {
        this.isData = true
      }
    },

    // 查看详情
    async CheckTheFinancing () {
      this.show = true
      try {
        const data = await findOrderDetail(this.id)
        if (data.error_code === 1) {
          this.financingDetails = data.data
        } else {
          this.$toast('请求失败')
        }
      } catch (error) {
        return error.message
      }
    },

    // 删除
    delese () {
      this.$dialog
        .confirm({
          title: '是否确认删除?',
          confirmButtonColor: '#2DADB1'
        })
        .then(() => {
          this.DeleseData()
        })
        .catch(() => {
          this.$dialog.close()
        })
    },
    async DeleseData () {
      try {
        const data = await ModifyState(this.id)
        if (data.error_code === 1) {
          this.financingList = delItem(this.financingList, this.id)
          this.$toast('删除成功')
        } else {
          this.$toast('删除失败')
        }
      } catch (error) {
        return error.message
      }
    }
  }
}
</script>
